import { render, staticRenderFns } from "./UpdatePaymentDetails.vue?vue&type=template&id=53f5ed55"
import script from "./UpdatePaymentDetails.vue?vue&type=script&lang=js"
export * from "./UpdatePaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./UpdatePaymentDetails.vue?vue&type=style&index=0&id=53f5ed55&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports